// extracted by mini-css-extract-plugin
export default {"promptChoices":"m"};